import 'core-js/fn/array/flat-map'
import Vue from 'vue'
import Vuex from 'vuex'
import App from '@/App'
import router from '@/router'
import buildStore from '@/store'
import useFilters from '@/vueHelpers/filters'
import vuetify from './plugins/vuetify'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

Vue.use(Vuex)

Vue.use(Chartkick.use(Chart))

Vue.component('quillEditor', quillEditor)

Vue.config.productionTip = false

useFilters(Vue)
Vue.prototype.$initialStateCopy = JSON.parse(JSON.stringify(buildStore().state))

new Vue({
  router,
  store: buildStore(),
  vuetify,
  render: h => h(App)
}).$mount('#app')
